/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpRespBuyerAssuranceBox_user$ref = any;
type PdpRespDealerDetails_user$ref = any;
type PdpRespHeroCarousel_user$ref = any;
type PdpRespIconBubblesWrapper_user$ref = any;
type PdpRespShippingReturns_user$ref = any;
type PdpRespSidebarBlurbs_user$ref = any;
type PdpRespSidebarButtons_user$ref = any;
type PdpRespSidebarContact_user$ref = any;
type PdpRespSidebarSellerInfo_user$ref = any;
type PdpRespSimilarItemsFooter_user$ref = any;
type PdpRespSimilarItemsGridSeller_user$ref = any;
type PdpSharedPromoCode_user$ref = any;
type PdpSharedSwatchSelector_user$ref = any;
type PdpSharedTradeRewardsBenefitCardLoader_user$ref = any;
type SharedRecentlyViewedItems_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespContainer_user$ref: FragmentReference;
export type PdpRespContainer_user = {|
  +$fragmentRefs: PdpRespSimilarItemsGridSeller_user$ref & PdpRespSimilarItemsFooter_user$ref & PdpRespSidebarButtons_user$ref & PdpRespSidebarBlurbs_user$ref & PdpRespShippingReturns_user$ref & PdpRespBuyerAssuranceBox_user$ref & PdpRespSidebarContact_user$ref & PdpRespHeroCarousel_user$ref & PdpRespIconBubblesWrapper_user$ref & PdpRespDealerDetails_user$ref & PdpRespSidebarSellerInfo_user$ref & PdpSharedPromoCode_user$ref & PdpSharedTradeRewardsBenefitCardLoader_user$ref & PdpSharedSwatchSelector_user$ref & SharedRecentlyViewedItems_user$ref,
  +$refType: PdpRespContainer_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isMultiSku",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespHeroCarousel_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsGridSeller_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarButtons_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbs_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespShippingReturns_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespBuyerAssuranceBox_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarContact_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsFooter_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespIconBubblesWrapper_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespDealerDetails_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarSellerInfo_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedPromoCode_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedTradeRewardsBenefitCardLoader_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SharedRecentlyViewedItems_user",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isMultiSku",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "PdpSharedSwatchSelector_user",
          "args": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '9efd881569bc4a1dc792dd066eefaac0';
module.exports = node;
